/**
 * 项目配置
 */
export const Settings = {
  /**
   * 项目名称
   */
  projectName: '正泰品宣资源管理系统',
  /**
   * token在cookie中的名称
   * 命名规则 C_项目英文名称_T
   */
  tokenKey: 'C_ProductPromotion_CloudStorage_T',
  /**
   * 是否自动重新授权
   * 此配置决定在身份令牌失效后是否自动跳转派拉重新认证
   */
  autoReAuthorize: true
};
